import type { GetSlugEntryResponse } from '../../utils/requests/contentstack/slug';
import { LandingPageCustom } from '../LandingPageCustom';
import { type LayoutProps } from '../Layout';
import { ModularPageWrapper } from '../ModularPageWrapper';

export type SlugEntryPageLayoutProps = GetSlugEntryResponse & {
  viewEventTrackingName?: LayoutProps['viewEventTrackingName'];
};

export const SlugPageLayout = (props: SlugEntryPageLayoutProps) => {
  if (props.contentType === 'landing_page_custom') {
    return (
      <LandingPageCustom
        viewEventTrackingName={props.viewEventTrackingName}
        {...props.data}
      />
    );
  }

  if (props.contentType === 'modular_page') {
    return (
      <ModularPageWrapper
        viewEventTrackingName={props.viewEventTrackingName}
        {...props.data}
      />
    );
  }

  return null;
};
